// extracted by mini-css-extract-plugin
export var base = "_14-0";
export var updateBanner = "_14-1";